//src/features/dashboard/pages/EmployeeCompliancePage.tsx

import { useEffect } from 'react';

import { useLoaderContext } from '../../../../components/Loader/LoaderContext';
import DashboardHeader from '../../components/DashboardHeader';

import ComplianceHeader from '../../components/EmployeeCompliance/ComplianceHeader';
import ComplianceCard from '../../components/EmployeeCompliance/ComplianceCard';

import useEmployeeCompliance from '../../hooks/Employee/useEmployeeCompliance';

import ComplianceLoginChart from "../../components/EmployeeCompliance/ComplianceLoginChart";
// import ComplianceBreakChart from "../../components/EmployeeCompliance/ComplianceBreakChart";
import ComplianceHoursChart from "../../components/EmployeeCompliance/ComplianceHoursChart";
import CompliancePolicyChart from "../../components/EmployeeCompliance/CompliancePolicyChart";
import ComplianceHeatmap from "../../components/EmployeeCompliance/ComplianceHeatmap";



const EmployeeCompliancePage = () => {

     const { hideLoader } = useLoaderContext();

const {
  header,
  cards,

  loginChart,
  loginTable,


  hoursChart,
  hoursTable,

  policyChart,
  policyTable,

  heatmapData,

  loading,

  headerError,
  loginError,
  hoursError,
  policyError,
  heatmapError,
} = useEmployeeCompliance();
useEffect(() => {
    if (!loading) {
        const timer = setTimeout(() => {
        hideLoader();
        }, 500);

        return () => clearTimeout(timer);
    }
    }, [loading, hideLoader]);

    if (loading) {
    return null;
    }

  // if (error) {
  //   return (
  //     <div className="rounded-xl border border-red-200 bg-red-50 p-6 text-red-600">
  //       {error}
  //     </div>
  //   );
  // }

  return (
    <>
    
      <DashboardHeader
  breadcrumbs={[
    {
      label: 'Work Vista',
      path: '/',
    },
    {
      label: 'My Dashboard',
      path: '/employee-dashboard',
    },
    {
      label: 'Compliance',
    },
  ]}
/>
  <div
  className="
    -mt-[8px]
    rounded-[16px]
    border
    border-[#D0D5DD]
    bg-[#F8F9FB]
    p-[18px]
  "
>
   <ComplianceHeader header={header} />

   {headerError ? (
  <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-red-600">
    {headerError}
  </div>
) : (
  <>
   
   <div className="mt-4">
  <ComplianceCard cards={cards} />
  </div>

  </>
)}
  <div className="mt-6 grid grid-cols-1 gap-6 xl:grid-cols-2">
  <div className="xl:col-span-2">
    {loginError ? (
      <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-red-600">
        {loginError}
      </div>
    ) : (
      <ComplianceLoginChart
        data={loginChart}
        tableData={loginTable}
      />
    )}
  </div>
</div>

<div className="mt-6 grid grid-cols-1 gap-6 xl:grid-cols-2">
  {hoursError ? (
    <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-red-600">
      {hoursError}
    </div>
  ) : (
    <ComplianceHoursChart
      data={hoursChart}
      tableData={hoursTable}
    />
  )}

  {policyError ? (
    <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-red-600">
      {policyError}
    </div>
  ) : (
    <CompliancePolicyChart
      data={policyChart}
      tableData={policyTable}
    />
  )}
</div>



<div className="mt-6">
  {heatmapError ? (
    <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-red-600">
      {heatmapError}
    </div>
  ) : (
    <ComplianceHeatmap
      data={heatmapData.rows}
      period={heatmapData.period}
      subtitle={heatmapData.subtitle}
    />
  )}
</div>
</div>

     
      
    </>
  );
};

export default EmployeeCompliancePage;